import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";
import { TostadorFetching } from "../../../class/fetchTostador";
import "../Tostador.css";

export default function PerfilMinerologicoConcentradoAlimentado() {
  // Objeto inicial de la peticion
  const initialFetch = new TostadorFetching().setIdSeccion(4).setSecuencia(20);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  const [calcoPirita, setCalcoPirita] = useState(defaultObject);
  const [calcosina, setCalcosina] = useState(defaultObject);
  const [bornita, setBornita] = useState(defaultObject);
  const [enargita, setEnargita] = useState(defaultObject);
  const [tenantita, setTenantita] = useState(defaultObject);
  const [pirita, setPirita] = useState(defaultObject);
  const [ganga, setGanga] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateCalcoPirita(data);
      populateCalcosina(data);
      populateBornita(data);
      populateEnargita(data);
      populateTenantita(data);
      populatePirita(data);
      populateGanga(data);
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateGanga(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Ganga Alimentación desde modelo Domo"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setGanga({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePirita(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Pirita Alimentación desde modelo Domo"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setPirita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTenantita(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) =>
        element.Detalle === "%Tenantita Alimentación desde modelo Domo"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTenantita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateEnargita(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) =>
        element.Detalle === "%Enargita Alimentación desde modelo Domo"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setEnargita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateBornita(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Bornita Alimentación desde modelo Domo"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setBornita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCalcoPirita(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) =>
        element.Detalle === "%Calcopirita Alimentación desde modelo Domo"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCalcoPirita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCalcosina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) =>
        element.Detalle === "%Calcosina Alimentación desde modelo Domo"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCalcosina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Mineralógico de Concentrado Alimentado"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- %Calcopirita Conc. Estimado --------------------------------------- */}
            <Chart.Line
              name="% Calcopirita Conc. Estimado"
              data={calcoPirita.value}
              yAxis={0}
            />

            {/** -------------------------------- %Calcosina Conc. Estimado --------------------------------------- */}
            <Chart.Line
              name="% Calcosina Conc. Estimado"
              data={calcosina.value}
              yAxis={0}
            />

            {/** -------------------------------- %Bornita Conc. Estimado --------------------------------------- */}
            <Chart.Line
              name="% Bornita Conc. Estimado"
              data={bornita.value}
              yAxis={0}
            />

            {/** -------------------------------- %Enargita Conc. Estimado --------------------------------------- */}
            <Chart.Line
              name="% Enargita Conc. Estimado"
              data={enargita.value}
              yAxis={1}
            />

            {/** -------------------------------- %Tenantita Conc. Estimado --------------------------------------- */}
            <Chart.Line
              name="% Tenantita Conc. Estimado"
              data={tenantita.value}
              yAxis={1}
            />

            {/** -------------------------------- %Pirita Conc. Estimado --------------------------------------- */}
            <Chart.Line
              name="% Pirita Conc. Estimado"
              data={pirita.value}
              yAxis={0}
            />

            {/** -------------------------------- %Ganga Conc. Estimado --------------------------------------- */}
            <Chart.Line
              name="% Ganga Conc. Estimado"
              data={ganga.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={calcoPirita.fecha} />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido Cpy - Cc - Bo - Py - Gangas, %"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={60}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title=" Contenido En - Ten, %"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
              max={30}
            />

            <Chart.Tooltip valueSuffix=" % " />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
